module.exports = __webpack_public_path__ + "static/assets/a6cebfe99bad7b01f59b85998cbc4628.svg";